import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { updateAssetAccess } from '@api/assetAccess';

import { IUpdateAssetAccessDTO } from '@interfaces/assets/dto/assetAccessDTO';

import { EUserRoles } from '@enums/common';

import {
	ASSET_ACCESS,
	ASSET_ACCESS_RESTRICTED,
	ASSET_ACCESS_UPDATE,
} from '@constants/queryKeys';

interface IUseMutateUpdateAssetAccessReturned {
	updateAssetAccess: UseMutateFunction<any, any, IUpdateAssetAccessDTO, any>;
	isLoadingUpdateAssetAccess: boolean;
}

export const useMutateUpdateAssetAccess = (): IUseMutateUpdateAssetAccessReturned => {
	const queryClient = useQueryClient();

	const {
		mutate,
		isLoading,
	} = useMutation<IUpdateAssetAccessDTO>({
		mutationKey: [ASSET_ACCESS_UPDATE],
		allowedRoles: [EUserRoles.platformOwnerAdministrator],
		mutationFn: updateAssetAccess,
		onSuccess: () => {
			return [
				queryClient.invalidateQueries([ASSET_ACCESS_RESTRICTED]),
				queryClient.invalidateQueries([ASSET_ACCESS]),
			];
		},
	});

	return {
		updateAssetAccess: mutate,
		isLoadingUpdateAssetAccess: isLoading,
	};
};
